<div class="corporate-loans-pricing-component container-fluid">
  <div class="readMode">
    <mat-card appearance="outlined">
      <mat-card-content>
        @if (!isInternalUser) {
          <div class="row separator-bottom">
            <div class="col-lg-6 col-md-12">
              <message-box title="Info" type="info">
                Not available for external brokers
              </message-box>
            </div>
          </div>
        }

        @if (lastEditedByUser) {
          <div class="row separator-bottom">
            <div class="col-lg-6 col-md-12">
              <message-box title="Info" type="info">
                Last edited by: {{lastEditedByUser}}
              </message-box>
            </div>
          </div>
        }

        @if (isInternalUser) {
          <div class="row">
            <div class="col-12">
              <table mat-table [dataSource]="dataSource">
                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef>Name</th>
                  <td mat-cell *matCellDef="let data">
                    <span [ngClass]="{highlight: (data.highlight && data.highlight(data.value))}">
                      {{data.name}}
                    </span>
                  </td>
                </ng-container>
                <ng-container matColumnDef="value">
                  <th mat-header-cell *matHeaderCellDef>Value</th>
                  <td mat-cell *matCellDef="let data">
                    @if (data.type == 'text') {
                      <span [ngClass]="{highlight: (data.highlight && data.highlight(data.value))}">{{data.value ?? ''}}</span>
                    }
                    @if (data.type == 'currency') {
                      <span [ngClass]="{highlight: (data.highlight && data.highlight(data.value))}">{{data.value | looseCurrency}}</span>
                    }
                    @if (data.type == 'percentage') {
                      <span [ngClass]="{highlight: (data.highlight && data.highlight(data.value))}">{{(data.value ?? '') | percentage:'1.0-2' }}</span>
                    }
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="['name', 'value']"></tr>
                <tr mat-row *matRowDef="let row; columns: ['name', 'value']"></tr>
              </table>
            </div>
          </div>
        }
      </mat-card-content>
    </mat-card>
  </div>
</div>
